import type { RouteRecordRaw } from "vue-router";
const onError = (err: any) => {
  console.error("Failed to load async component: ", err);
  throw new Error(err);
};

const RiskControl: RouteRecordRaw = {
  name: "风控平台",
  path: "/risk-control",
  component: () => import("@/components/Layout/index.vue").catch(onError),
  redirect: "/risk-control/index",
  meta: {
    key: "/risk-control"
  },
  children: [
    {
      name: "指标管理",
      path: "index",
      meta: {
        key: "/risk-control/index"
      },
      component: () =>
        import("@/views/RiskControl/RiskIndex/index.vue").catch(onError)
    },
    {
      name: "运营风险",
      path: "operation",
      meta: {
        key: "/risk-control/operation"
      },
      component: () =>
        import("@/views/RiskControl/OperationRisk/index.vue").catch(onError)
    },
    {
      name: "AF账户监控配置",
      path: "account-monitoring",
      meta: {
        key: "/risk-control/account-monitoring"
      },
      component: () =>
        import("@/views/RiskControl/AccountMonitoring/index.vue").catch(onError)
    },
    {
      name: "流量风控",
      path: "flow",
      meta: {
        key: "/risk-control/flow"
      },
      component: () =>
        import("@/views/RiskControl/FlowRisk/index.vue").catch(onError)
    }
  ]
};

export default RiskControl;
